export default {
    maintenanceDeleteMaintenanceServiceUnit_description: 'Está seguro de que desea eliminar el Servicio de Mantenimiento',
    maintenanceDeleteMaintenanceServiceUnit_success_message: 'Servicio de mantenimiento eliminado con éxito',
}